import { ref, watch, onMounted, onUnmounted } from 'vue'
import debounce from 'gleam-shared/helpers/debounce'

import LazyEmbed from 'gleam-shared/lazyEmbed'

export default function useLazyEmbed(root) {
  let manager = null
  const error = ref(null)
  const debouncedInit = debounce(init)

  watch(root, debouncedInit)
  onMounted(debouncedInit)
  onUnmounted(clear)

  return error

  function init() {
    clear()

    if (root.value) {
      manager = LazyEmbed(root.value)
      manager.errorEmitter.on((err) => {
        error.value = err
      })
    }
  }

  function clear() {
    manager?.destroy()
    debouncedInit.cancel()
  }
}
